import React, {
  useState, useEffect, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import apiFetch from 'utils/apiFetch';
import { TABLET_WIDTH } from 'constants/breakPoints';
import AlertModal from 'components/FeedbackModal';
import ThemeTableBubbles from 'components/ThemeTablesBubbles';
import Faces from 'components/Steps/Faces';
import AutocompleteInput from 'components/AutocompleteInput';
import ElementCard from 'components/Cards/ElementSimpleCard';
import UsersModal from 'components/UsersModal';
import SimpleCarousel from 'components/SimpleCarousel';
import { STATUS_INIT, STATUS_SUCCESS, STATUS_FAILURE } from 'constants/status';
import { ROUTE_THINK_SEED_CREATION } from 'constants/urls';
import { CALL_FOR_IMPACT } from 'constants/types';
import NoResultsImg from 'assets/images/no_results.svg';
import Loading from 'components/LoadingComponent';
import addLogo from 'assets/images/addLogo.svg';
import { NetworkingHallSection, LoadingWrapper } from 'components/People/components/styles';
import { CreateTable } from './styles';

function Topics(props) {
  const {
    elementType, elementId, literals, app, history, actualUser,
  } = props;
  const { color1 } = app;

  const [topics, setTopics] = useState([]);
  const [statusRequest, setStatusRequest] = useState(STATUS_INIT);
  const [selectedTopic, setSelectedTopic] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // Errors
  const [errors, setErrors] = useState([]);

  const removeErrors = () => {
    setErrors([]);
  };

  const printErrors = () => {
    if (!errors.length) {
      return null;
    }
    return (
      <AlertModal
        onClose={removeErrors}
        open
        success={false}
        text={errors.join('<br />')}
      />
    );
  };

  // Tags
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  // Searcher
  const handleSearcher = (value) => {
    const valueId = parseInt(value, 10);
    const newSelectedTags = [...selectedTags];
    if (!_.find(newSelectedTags, tagValue => tagValue === valueId)) {
      newSelectedTags.push(valueId);
    }

    const newTags = _.remove(tags, { id: valueId }).concat(tags);

    setSelectedTags(newSelectedTags);
    setTags(newTags);
  };

  const handleSelectOptionSearcher = (option) => {
    handleSearcher(option.id);
  };

  const printSearcher = () => {
    const options = _.map(tags, tag => ({
      value: tag.id,
      label: tag.name,
    }));
    return <AutocompleteInput type='tag' placeholder={literals.searchTopics} onSelectOption={handleSelectOptionSearcher} options={options} async={false} />;
  };

  // Load data
  const searchTopics = () => {
    const params = {};
    if (elementType) {
      params.element_type = elementType;
    }
    if (elementId) {
      params.element_id = elementId;
    }

    setSelectedTopic(0);
    setTopics([]);
    setTags([]);
    setStatusRequest(STATUS_INIT);
    setIsLoading(true);
    apiFetch('GET', { endPoint: 'networking-hall/topics' }, params)
      .then((response) => {
        setIsLoading(false);
        const finalTags = [];
        _.forEach(response.data, (topic) => {
          if (typeof topic.related_elements !== 'undefined') {
            _.forEach(topic.related_elements, (element) => {
              if (!_.find(finalTags, { id: element.id })) {
                finalTags.push(element);
              }
            });
          }
        });
        setTags(finalTags);
        setTopics(response.data);
        setStatusRequest(STATUS_SUCCESS);
      })
      .catch((error) => {
        setIsLoading(false);
        errors.push(error.response.data.error);
        setErrors([...errors]);
        setStatusRequest(STATUS_FAILURE);
      });
  };

  useEffect(() => {
    searchTopics();
  }, [elementType, elementId]);

  // Filter by tags
  useEffect(() => {
    if (!selectedTags.length) {
      window.$('.theme_bubble').removeClass('not_pass_filter');
    } else {
      _.forEach(topics, (topic) => {
        let hasTag = false;
        if (typeof topic.related_elements !== 'undefined') {
          hasTag = true;
          _.forEach(selectedTags, (selectedTag) => {
            if (!_.find(topic.related_elements, { id: selectedTag })) {
              hasTag = false;
            }
          });
        }

        if (hasTag) {
          window.$(`.theme_bubble[data-id=${topic.id}]`).removeClass('not_pass_filter');
        } else {
          window.$(`.theme_bubble[data-id=${topic.id}]`).addClass('not_pass_filter');
        }
      });
    }
  }, [selectedTags]);


  const selectTag = (event) => {
    const id = parseInt(event.currentTarget.getAttribute('data-id'), 10);
    const newSelectedTags = [...selectedTags];
    if (_.find(newSelectedTags, tagId => tagId === id)) {
      _.remove(newSelectedTags, tagId => tagId === id);
    } else {
      newSelectedTags.push(id);
    }
    setSelectedTags(newSelectedTags);
  };

  const printTags = () => {
    return _.map(tags, (tag) => {
      return (
        <div
          className={`tag_filter ${_.find(selectedTags, selectedTag => selectedTag === tag.id) ? 'selected' : ''}`}
          key={tag.id}
          data-id={tag.id}
          onClick={selectTag}
        >
          {tag.name}
        </div>
      );
    });
  };

  // Select user
  const [selectedUser, setSelectedUser] = useState(null);

  const handleClickUserBubble = (userId) => {
    let users = [];

    _.forEach(topics, (topic) => {
      if (!selectedTopic || selectedTopic === topic.id) {
        users = users.concat(topic.users);
      }
    });
    const user = _.find(users, { id: userId });
    setSelectedUser(user);
  };

  const removeSelectedUser = () => {
    setSelectedUser(null);
  };

  const printSelectedUser = () => {
    if (!selectedUser) {
      return null;
    }

    let users = [];

    _.forEach(topics, (topic) => {
      if (!selectedTopic || selectedTopic === topic.id) {
        users = users.concat(topic.users);
      }
    });

    return (
      <UsersModal
        usersIds={_.map(users, user => user.id)}
        userSelected={selectedUser.id}
        onEnd={removeSelectedUser}
      />
    );
  };


  // Selected topic
  const goToTable = (id) => {
    if (id) {
      setSelectedTopic(id);
      history.push(`/theme-table/${id}`);
    }
  };

  const printUsers = () => {
    const users = [];

    _.forEach(topics, (topic) => {
      if (!selectedTopic || selectedTopic === topic.id) {
        _.forEach(topic.users, (user) => {
          if (!_.find(users, { id: user.id })) {
            users.push(user);
          }
        });
      }
    });

    if (!users.length) {
      return null;
    }

    let title = literals.peopleInAllTables;
    if (selectedTopic) {
      const topic = _.find(topics, { id: selectedTopic });
      title = `${literals.peopleIn} ${topic.name}`;
    }

    return (
      <div className='list'>
        <div className='header'>
          <div className='title'>{title}</div>
        </div>
        <SimpleCarousel classesList='face_bubble'>
          <Faces
            options={users}
            onClick={handleClickUserBubble}
            onLongPress={handleClickUserBubble}
          />
        </SimpleCarousel>
      </div>
    );
  };

  const printMainElements = () => {
    if (!app.main_element) {
      return null;
    }

    const mainElements = [];
    _.forEach(topics, ({ users }) => {
      _.forEach(users, ({ elements }) => {
        if (typeof elements[app.main_element] !== 'undefined' && elements[app.main_element].length) {
          _.forEach(elements[app.main_element], (element) => {
            if (!_.find(mainElements, { id: element.id })) {
              mainElements.push(element);
            }
          });
        }
      });
    });

    if (!mainElements.length) {
      return null;
    }

    let title = `${literals.elements[app.main_element] || app.main_element} `;
    if (selectedTopic) {
      const topic = _.find(topics, { id: selectedTopic });
      title += `${literals.in} ${topic.name}`;
    } else {
      title += literals.inAllTables;
    }

    return (
      <div className='list'>
        <div className='header'>
          <div className='title'>{title}</div>
        </div>
        <SimpleCarousel classesList='simple_card_element'>
          {_.map(mainElements, element => (
            <ElementCard data={element} key={element.id} classesList={['simple_card_element']} />
          ))}
        </SimpleCarousel>
      </div>
    );
  };

  const showTopicDetailView = () => {
    switch (elementType) {
      case CALL_FOR_IMPACT:
        history.push(`/calls/${elementId}/theme-table/${selectedTopic}`);
        break;
      default:
        history.push(`/theme-table/${selectedTopic}`);
        break;
    }
  };

  const printSelectedTopic = () => {
    return (
      <React.Fragment>
        {printUsers()}
        {printMainElements()}
        {selectedTopic ? (
          <div className='form'>
            <div className='form_buttons'>
              <button className='primary' onClick={showTopicDetailView}>{literals.viewDetails}</button>
            </div>
          </div>
        ) : null}
      </React.Fragment>);
  };

  const handleCreateThinkChat = () => {
    let url = ROUTE_THINK_SEED_CREATION;
    if (elementType === CALL_FOR_IMPACT) {
      url = `${url}/call/${elementId}`;
    }
    history.push(url);
  };

  const printCreateTableButton = () => {
    return (
      <CreateTable>
        <button onClick={handleCreateThinkChat}>
          <img src={addLogo} alt='' />
        </button>
      </CreateTable>
    );
  };

  const printGravityBubbles = () => {
    if (!topics.length) {
      return null;
    }
    const maxPoints = _.maxBy(topics, 'points').points;
    const minPoints = _.minBy(topics, 'points').points;
    const difference = Math.max(maxPoints - minPoints, 1);
    const interval = difference / 3;
    const limitBig = maxPoints - interval;
    const limitMedium = limitBig - interval;

    const finalTopics = _.map(topics, (topic) => {
      let color = '#BBE8F8';

      switch (topic.type) {
        case 'think_seed':
          color = topic.status.id === 21227337 ? '#ddd' : app.color1;
          break;
        case 'think_tank':
          color = '#3BBCEB';
          break;
        default:
          color = '#F4F4F4';
          break;
      }

      let size = 'xs';
      if (topic.points >= limitBig) {
        size = 'lg';
      } else if (topic.points >= limitMedium) {
        size = 'md';
      }

      const satellites = [];
      const mainElements = [];
      let isInTable = false;

      _.forEach(topic.users, (user) => {
        if (actualUser && actualUser.id === user.id) {
          isInTable = true;
        }
        const userSize = 'xs';
        const satellite = {
          id: user.id,
          name: `${user.firstname} ${user.lastname}`,
          image: user.avatar,
          size: userSize,
        };

        satellites.push(satellite);

        if (app.main_element && user.elements[app.main_element]) {
          _.forEach(user.elements[app.main_element], (element) => {
            if (!_.find(mainElements, { id: element.id })) {
              const finalElement = {
                id: element.id,
                name: element.name,
                image: element.image,
              };
              mainElements.push(finalElement);
            }
          });
        }
      });

      const isNew = Math.floor((moment().unix() - topic.timestamp) / 86400) <= 2;
      const finalTopic = {
        id: topic.id,
        name: topic.name,
        image: topic.image,
        tags: typeof topic.related_elements !== 'undefined' ? _.map(topic.related_elements, tag => tag.name) : [],
        color,
        size,
        satellites,
        isNew,
        inline_elements: mainElements,
        highlighted: isInTable,
      };

      return finalTopic;
    });

    return (
      <div className={`theme_tables_wrapper ${elementType ? 'with_header' : ''}`}>
        <ThemeTableBubbles
          data={finalTopics}
          onClick={goToTable}
          // onFullscreen={changeFullscreen}
        />
      </div>
    );
  };

  const gravityBubbles = useMemo(() => (
    <div className='gravity_bubbles_wrapper'>{printGravityBubbles()}</div>
  ), [topics]);

  const printContent = () => {
    if (statusRequest !== STATUS_SUCCESS) {
      return null;
    }

    if (!topics.length) {
      return (
        <div className='no_elements'>
          <img alt='' src={NoResultsImg} />
          <div>{literals.noTopics}</div>
        </div>
      );
    }
    const lists = selectedTopic || window.outerWidth <= TABLET_WIDTH ? (
      <div className='lists'>
        {printSelectedTopic()}
      </div>) : null;
    return (
      <div className='content gravity_bubbles fullscreen'>
        {gravityBubbles}
        {lists}
      </div>
    );
  };

  if (isLoading) {
    return (<LoadingWrapper><Loading /></LoadingWrapper>);
  }


  return (
    <React.Fragment>
      <NetworkingHallSection color={color1}>
        {printErrors()}
        {printSelectedUser()}
        <div className='search_bar form'>
          <div className='form_question_input'>
            {printSearcher()}
            <div className='filters_tags'>{printTags()}</div>
          </div>
        </div>
        {printContent()}
      </NetworkingHallSection>
      {printCreateTableButton()}
    </React.Fragment>
  );
}

Topics.propTypes = {
  literals: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  actualUser: PropTypes.object,
  elementType: PropTypes.string,
  elementId: PropTypes.number,
};

Topics.defaultProps = {
  elementType: null,
  elementId: null,
  actualUser: null,
};

export default Topics;



// WEBPACK FOOTER //
// ./src/components/Topics/components/index.jsx